module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1049-562a3844c1c58909657dd1f6c36a67e6.png";